import { HTTPError } from 'services/api/entities';
import { Nullable } from 'types';

export enum RequestStatus {
  Loading = 'REQUEST_LOADING',
  Success = 'REQUEST_SUCCESS',
  Error = 'REQUEST_ERROR',
}

export type BaseAction = {
  type: string;
};
export type PayloadAction<T> = BaseAction & {
  payload: Nullable<T>;
};

export type RequestState<T> = {
  loading: boolean;
  error: Nullable<HTTPError>;
  response: Nullable<T>;
};
